export class CheckButtonResponse {
  existe: boolean;
  error: string;

  constructor() { }

  static toModel(json: string): CheckButtonResponse {
    const data = JSON.parse(json);
    const toReturn = new CheckButtonResponse();
    toReturn.existe = data.EXISTE;
    toReturn.error = data.ERROR;
    return toReturn;
  }
}
